import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { loadingComponent } from './loading.component';

@NgModule({
  declarations: [loadingComponent],
  exports: [loadingComponent],
  imports: [CommonModule],
})
export class LoadingModule {}
